import React from 'react';

function MembershipCard({ membership, activePeriod }) {
  const hasMostPopular = membership.badges.includes('Most Popular');
  const hasBestValue = membership.badges.includes('Best Value');

  return (
    <article
      className={`pcard career-plan-card ${hasMostPopular ? 'is-most-popular' : ''} ${hasBestValue ? 'is-best-value' : ''}`}
      aria-label={`${membership.name} membership`}
    >
      <div className="pcard-body">
        <header className="career-plan-card__header">
          <div className="career-plan-card__icon" aria-hidden="true">{membership.icon}</div>
          <div>
            <h3>{membership.name}</h3>
            <p>{membership.tagline}</p>
          </div>
        </header>

        {membership.badges.length > 0 ? (
          <div className="career-plan-card__badges">
            {membership.badges.map((badge) => (
              <span key={badge}>{badge}</span>
            ))}
          </div>
        ) : null}

        <div className="career-plan-card__pricing">
          <div className="career-plan-card__price">{membership.prices[activePeriod]}</div>
          <div className="career-plan-card__price-period">{activePeriod === 'monthly' ? 'per month' : activePeriod === 'quarterly' ? 'per quarter' : 'for 6 months'}</div>
        </div>

        <p className="career-plan-card__ideal"><strong>Ideal for:</strong> {membership.idealFor}</p>

        <ul className="career-plan-card__focus" aria-label={`${membership.name} focus areas`}>
          {membership.focus.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>

        <div className="pcard-foot">
          <div className="price">
            <span className="now">{membership.prices[activePeriod]}</span>
          </div>
          <a className="btn btn-red btn-sm" href={membership.cta.href}>{membership.cta.label}</a>
        </div>
      </div>
    </article>
  );
}

export default MembershipCard;